export function initializePaymentIQForm(partyId, sessionKey, packageId, bonusCode, method) {

    if (typeof window._PaymentIQCashier !== 'undefined') {
        initCashier(partyId, sessionKey, packageId, bonusCode, method);
        return;
    }

    if (!document.getElementById('paymentiq-cashier-script')) {
        const script = document.createElement('script');
        script.id = 'paymentiq-cashier-script';
        script.type = 'text/javascript';
        script.src = 'https://pay.paymentiq.io/cashier/cashier.js';

        script.onload = () => waitForCashier(partyId, sessionKey, packageId, bonusCode, method);

        document.head.appendChild(script);

        console.log('add the cashier script');

    }
}

function waitForCashier(partyId, sessionKey, packageId, bonusCode, method) {
    const checkInterval = setInterval(() => {
        if (typeof window._PaymentIQCashier !== 'undefined') {
            clearInterval(checkInterval);
            initCashier(partyId, sessionKey, packageId, bonusCode, method);
        }
    }, 200);
}

function initCashier(partyId, sessionKey, packageId, bonusCode, method) {

    const merchantId = accountData.MERCHANT_ID;
    const piqEnv = accountData.PIQ_ENV;

    document.getElementById('paymentIframe').innerHTML = '';

    let CashierInstance = new _PaymentIQCashier('#paymentIframe', {
        "merchantId": merchantId,
        "userId": partyId,
        "locale": navigator.language ?? 'en-US',
        "sessionId": sessionKey, 
        "fetchConfig": true,
        "environment": piqEnv,
        "method": (method == 'DEPOSIT' ? 'deposit' : 'withdrawal'),
        "attributes": {
            "packageId": packageId,
            "bonusCode": bonusCode
        }
    },
        (api) => {
            api.on({
                update: data => console.log('The passed in data was set', data),
                success: data => console.log('Transaction was completed successfully', data),
                failure: data => console.log('Transaction failed', data),
                isLoading: data => console.log('Data is loading', data),
                doneLoading: data => console.log('Data has been successfully downloaded', data),
                newProviderWindow: data => console.log('A new window / iframe has opened', data)
            });
        });

};
